import { errorMessages } from '../model';

export const asyncActionWithRetry = async <T = unknown>(
    action: () => Promise<T>,
    attempts: number,
    isCancelled: () => boolean
): Promise<T> => {
    for (let i = 0; i < attempts - 1; i++) {
        try {
            const actionResult = await action();
            if (isCancelled()) {
                throw errorMessages.asyncOperationCancelled;
            }
            return actionResult;
        } catch {}
    }
    const result = await action();
    if (isCancelled()) {
        throw errorMessages.asyncOperationCancelled;
    }
    return result;
};
